import platform from '../platform';
import { versionCompare } from '../versionCompare';

/** 客户端存储方案，解决Android 新老容器 localstorage数据不共享的问题
 * Android 6.39.0版本开始支持
 * iOS 6.22.0版本之前开始支持（版本太久远，无法查询，按这个版本即可）
 * 鸿蒙 默认支持
*/
const isSupportNativeDataStorage = (): boolean => {
  const versionMatch = /version=([\d.]*)/.exec(navigator.userAgent);
  const appVersion = (versionMatch && versionMatch[1]) || '';
  if (platform.isHelloApp) {
    return !!(
      (platform.isAndroid && versionCompare(appVersion, '6.39.0') >= 0)
      || (platform.isIOS && versionCompare(appVersion, '6.22.0') >= 0)
      || (platform.isHarmony && true)
    );
  }

  return false;
};

export default isSupportNativeDataStorage;
